import { Label } from '../index';
import { colors } from '@material-ui/core';
import React from 'react';

export const ChangeLogNavBarLabel = () => <Label color={colors.blue['500']}>v1.2.0</Label>;
export const CalenderNavBarLabel = () => <Label color={colors.green[500]}>New</Label>;
export const ChatIconNavBarLabel = () => (
  <Label color={colors.red[500]} shape="rounded">
    4
  </Label>
);
export const MailNavBarLabel = () => (
  <Label color={colors.red[500]} shape="rounded">
    2
  </Label>
);
